import type { MappedProductVariant } from '@libs/algolia';
import type { IdentityUser, UserData } from '@libs/common-next';
import { getLocale, Locale, type Nullable } from '@libs/core';

export const getCustomerObject = (
    user: Nullable<IdentityUser>,
    userData: Nullable<UserData>
) => {
    return {
        customer: {
            customerInfo: {
                email: userData?.profile?.emailAddress ?? '',
                customerID: user?.customerprofileid
                    ? String(user.customerprofileid)
                    : '',
                janrainID: '',
                registrationStatus:
                    Boolean(user) && Boolean(userData)
                        ? 'Existing Registration'
                        : '',
            },
        },
    };
};

export const getProductObject = (
    product: MappedProductVariant,
    categories: string[]
) => ({
    product: {
        category: {
            categoryId: product.primary_category_id ?? '',
            pageType: 'Product Detail',
            primaryCategory: categories[0] ?? '',
            subCategory1: categories[1] ?? '',
            subCategory2: categories[2] ?? '',
            subCategory3: categories[3] ?? '',
        },
        productInfo: {
            brand: product.brand ?? '',
            productName: product.name ?? '',
            price: product.price?.number ?? 0,
            productID: product.objectID,
        },
    },
});

export const getPageData = (categories: string[], pageType: string) => {
    const locale = getLocale();
    const localeAttr =
        locale === Locale['en-US']
            ? {
                  country: 'us',
                  language: 'en',
              }
            : {
                  country: 'ca',
                  language: 'en_CA',
              };
    return {
        page: {
            attributes: {
                ...localeAttr,
                server: window.location.hostname,
                pageType,
            },
            category: {
                primaryCategory: categories[0] ?? '',
                subCategory1: categories[1] ?? '',
                subCategory2: categories[2] ?? '',
                subCategory3: categories[3] ?? '',
            },
        },
    };
};
